import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"

import Commission from "./Commission"

import gridStyles from "../../../components/Plans.module.css"

const Commissions = ({
  commissions,
  isDiscountApplied,
  lang,
  price,
  showLabel,
}) => {
  const { t: translate } = useTranslate()
  return (
    <div className="flex-container f-a-center f-d-col">
      <div className="flex-container f-a-center f-j-center">
        {commissions.map((c, index) => (
          <Commission
            key={`COMMISSION_${c.value}_${c.unit}`}
            commission={c}
            isDiscountApplied={isDiscountApplied}
            lang={lang}
            price={price}
            isLastCommission={commissions.length === index + 1}
          />
        ))}
      </div>
      {showLabel && (
        <label
          className={`${gridStyles.perPeriodLabel} fs-14 w300 m-b-0 textCenter`}
        >
          {translate("per transaction")}
        </label>
      )}
    </div>
  )
}

Commissions.propTypes = {
  commissions: PropTypes.array,
  isDiscountApplied: PropTypes.bool,
  lang: PropTypes.string,
  price: PropTypes.object,
  showLabel: PropTypes.bool,
}
Commissions.defaultProps = {
  commissions: [],
  isDiscountApplied: false,
  lang: "en",
  price: {},
  showLabel: true,
}

export default Commissions
